<template>
  <div class="clientAccountDetails">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-date-picker
            v-model="form.accountStartTime"
            type="datetime"
            placeholder="开户开始时间"
          ></el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
            v-model="form.accountEndTime"
            type="datetime"
            placeholder="开户结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="form.activeStartTime"
            type="datetime"
            placeholder="激活开始时间"
          ></el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
            v-model="form.activeEndTime"
            type="datetime"
            placeholder="激活结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.account" placeholder="交易账号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.agent" placeholder="请选择代理">
            <el-option
              v-for="item in form.agentData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.utmSource" placeholder="来源"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.utmMedium" placeholder="媒介"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.utmContent" placeholder="广告系列"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.utmCampaign" placeholder="广告组"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.utmTerm" placeholder="关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small">{{$t('common.reset')}}</el-button>
          <el-button type="primary" size="small">{{$t('common.search')}}</el-button>
          <el-button type="primary" size="small">{{$t('common.export')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column :prop="item.id" :label="item.name" v-for="item in tableNav"></el-table-column>
      </el-table>
      <div class="flexEnd" v-if="totalNum>0">
        <el-pagination
          background
          small
          @current-change="changeCurrentClientAccountList"
          :current-page="currentPage"
          :page-size="pageSize"
          :pager-count="10"
          layout="total, prev, pager, next, jumper"
          :total="totalNum">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import Util from '@/utils/IM/tradeDataUtil'
  import nationalMarketing from '@/api/nationalMarketing/nationalMarketing'
  export default {
    name: 'clientAccountDetails',
    data() {
      return {
        form: {
          accountStartTime: new Date(),
          accountEndTime: new Date(),
          activeStartTime: new Date(),
          activeEndTime: new Date(),
          account: '',
          agent: '',
          agentData: [],
          utmSource: '',
          utmMedium: '',
          utmContent: '',
          utmCampaign: '',
          utmTerm: ''
        },
        tableNav: [
          { name: '代理代号', id: 'agentCode' },
          { name: '交易平台', id: 'tradePlatform' },
          { name: '交易账号', id: 'account' },
          { name: '客户姓名', id: 'name' },
          { name: '开户时间', id: 'ctime' },
          { name: '激活时间', id: 'activeTime' },
          { name: '来源', id: 'utmSource' },
          { name: '媒介', id: 'utmMedium' },
          { name: '广告系列', id: 'utmContent' },
          { name: '广告组', id: 'utmCampaign' },
          { name: '关键字', id: 'utmTerm' }
        ],
        tableData: [],
        totalNum: 0,  //当前资源条数
        currentPage: 1,  //当前页数
        pageSize: 10 //当前页条数数
      }
    },
    methods: {
      getClientAccountData(data) {
        nationalMarketing.queryCustomerItemListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              let data = res.result.list
              for (const i in data) {
                if (Util.isNotEmpty(data[i].ctime)) {
                  data[i].ctime = new Date(data[i].ctime).format('Y-MM-dd hh:mm:ss')
                }
                if (Util.isNotEmpty(data[i].activeTime)) {
                  data[i].activeTime = new Date(data[i].activeTime).format('Y-MM-dd hh:mm:ss')
                }
              }
              this.tableData = data
              this.totalNum = res.result.total
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initClientAccountData() {
        let data = {
          pageNum: this.currentPage
        }
        this.getClientAccountData(data)
      },
      changeCurrentClientAccountList(val) {
        this.currentPage = val
        let data = {
          pageNum: val
        }
        this.getClientAccountData(data)
      }
    },
    mounted() {
      this.initClientAccountData()
    }
  }
</script>

<style lang="scss" scoped>
  .clientAccountDetails {
    margin: 20px;
    .flexEnd {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 20px;
    }
  }
</style>
